import React from "react";
import { css } from "@emotion/react";
import { Cruise } from "main/javascripts/types/cruise";
import { borderColor } from "main/javascripts/styles/base/colorStyle";
import { SaleCruisePriceListItem } from "./SaleCruisePriceListItem";

export interface IProps {
  salePrices: Cruise.SalePrice[];
  uniqueId: string;
  departureDate: string;
}

export const SaleCruisePriceList: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { salePrices, uniqueId, departureDate } = props;

  return (
    <div css={saleListStyle}>
      {salePrices.map((salePrice, index) => (
        <SaleCruisePriceListItem
          key={index}
          salePrice={salePrice}
          uniqueId={uniqueId}
          departureDate={departureDate}
        />
      ))}
    </div>
  );
};

const saleListStyle = css`
  width: 100%;
  border-top: 1px solid ${borderColor.primaryLightColor};
`;
